import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { validTenantGuard } from '@shared/routing/valid-tenant.guard';
import { PermissionCheckerService } from 'abp-ng2-module';
import { PermissionConsts } from '@shared/permission-consts';
import { AppSessionService } from '@shared/session/app-session.service';

const routes: Routes = [
    {
        path: '',
        redirectTo: () => {
            const permissionChecker = inject(PermissionCheckerService);
            const appSessionService = inject(AppSessionService);
            if (appSessionService.userId) {
                return permissionChecker.isGranted(PermissionConsts.Questionnaire_GetAll) ? '/app/surveys/list' : 'app/surveys/send-surveys';
            } else {
                return '/account/login';
            }
        },
        pathMatch: 'full',
    },
    {
        path: 'account',
        canActivate: [validTenantGuard],
        loadChildren: () => import('account/account.module').then((m) => m.AccountModule), // Lazy load account module
        data: { preload: true },
    },
    {
        path: 'app',
        canActivate: [validTenantGuard],
        loadChildren: () => import('app/app.module').then((m) => m.AppModule), // Lazy load account module
        data: { preload: true },
    },
    {
        path: '**',
        loadChildren: () => import('./fallback/fallback.module').then((m) => m.FallbackModule), // Lazy load fallback route
        data: { preload: true },
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            bindToComponentInputs: true, // Enables route params to be accessed via @Input decorator in components
            scrollPositionRestoration: 'enabled', // Resets scroll on route change
        }),
    ],
    exports: [RouterModule],
    providers: [],
})
export class RootRoutingModule {}
